<template lang="pug">

    .ui.horizontal.basic.segments

        //- ZMUEK-ID
        .ui.basic.segment
            h5.ui.header
                | Produkt-ID
                .sub.header {{ productModel.zmuekId }}

        //- Produkttyp
        .ui.basic.segment
            h5.ui.header
                | Typ
                .sub.header {{ productTypeModel.name }}

        //- Status
        .ui.basic.segment
            h5.ui.header
                | Produktstatus
                .sub.header {{ status }} 

        //- Druckdatenstatus
        .ui.basic.segment
            h5.ui.header
                | Druckdatenstatus
                .sub.header {{ printingDataStatus }} 

        //- Medienproduktioner
        .ui.basic.segment
            h5.ui.header
                | Medienproduktioner
                .sub.header {{ mediaProductionPersonModel.firstName }} {{ mediaProductionPersonModel.lastName }}

</template>

<script>
    import { get_printing_data_status_label, get_status_label }  from '@/utils/product'

    export default {

        computed: {

            printingDataStatus() {
                return get_printing_data_status_label(this.productModel.printingDataStatus)
            },

            status() {
                return get_status_label(this.productModel.status)
            }

        },

        props: {

            mediaProductionPersonModel: {
                type: Object,
                required: true
            },

            productModel: {
                type: Object,
                required: true
            },

            productTypeModel: {
                type: Object,
                required: true
            },

        }

    }

</script>

<style scoped>
    .ui.basic.segments {
       margin: 0; 
    }
</style>
